// extracted by mini-css-extract-plugin
export default {"container":"Verified_container__Cdv0U","notVerified":"Verified_notVerified__Eks0C"};